export default "__VITE_ASSET__CfMp6cDB__"